<template lang="pug">
li.dropdown-item
  a(
    :href="href"
    :disabled="disabled"
    :data-testid="dataTestId"
    :class="{ 'blank-link': disabled }"
    @click="onClick"
  )
    slot
</template>

<script>
export default {
  name: 'AppDropdownItem',
  props: {
    href: {
      type: String,
      default: '#',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataTestId: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClick(evt) {
      if (!this.disabled && this.href === '#') {
        evt.preventDefault();
        this.$emit('click', evt);
      }
    },
  },
};
</script>
